export default "__VITE_ASSET__BXd3YaxI__"